export const getStartedLink: () => void = () =>
window.open(`${window.spaSettings.partnerPortalDomain}register`, '_BLANK');


export const getStartedUrl: string =  `${window.spaSettings.partnerPortalDomain}register`;